// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3qlt_","column":"style_column__2cJ8u","row":"style_row__3EueP"};